import { Grid, styled, Theme } from "@mui/material";
import { brand } from "@platform/design-system";

import { LoginBackground } from "../assets";

export const LOGIN_PAGE_TEST_ID = "login-page";

/**
 * Full-height shell for the sign-in family of pages: brand artwork on the
 * right, a white panel on the left, collapsing to the panel alone below the
 * `lg` breakpoint.
 */
// The doubled selector keeps the specificity of the theme rule this replaces
// (`.MuiGrid-root.login-page`), so the link color still wins over the
// design-system Link's own color inside the panel.
export const LoginPage = styled(Grid)(({ theme }: { theme: Theme }) => {
  const white = theme.palette.common.white;
  return {
    "&&": {
      height: "100vh",
      background: `url(${LoginBackground})`,
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      backgroundPosition: "2px center",
      backgroundColor: white,
      a: {
        color: brand("primary")(theme),
        fontWeight: "bold",
      },
      "> div:first-of-type": {
        backgroundColor: white,
      },
      ".login-logo": {
        justifyContent: "flex-start",
        img: {
          marginLeft: "14.5%",
        },
      },
      [theme.breakpoints.down(theme.breakpoints.values.lg)]: {
        background: white,
        display: "flex",
        justifyContent: "center",
        "> div:first-of-type": {
          flexBasis: "80%",
          maxWidth: "80%",
          minWidth: "300px",
        },
        "> div:nth-of-type(2)": {
          display: "none",
        },
      },
    },
  };
}) as unknown as typeof Grid;
